<div>
  <div class="d-flex flex-row mb-2 align-items-baseline">
    <h2 class="mb-0 midgraytxt semibold">Trending Products</h2>
    <p class="ml-3 d-flex align-items-end" style="line-height: normal">
      <b>For {{ facilityName }}</b>
    </p>
    <dx-button
      class="ml-3 new-button ltgreen"
      type="default"
      style="position: relative; top: -3px"
      stylingMode="contained"
      text="View Full Catalog"
      (onClick)="goToCatalog()"
    ></dx-button>
  </div>
</div>

<div id="new-theme" *ngIf="catalogType">
  <app-catalog
    [trendingCatalog]="trendingCatalog"
    [catalogType]="catalogType"
    [sellerId]="null"
    (totalNumberOfListings)="populateTotalResults($event)"
  ></app-catalog>
</div>
